import { BodyShort01 } from 'module/ui/components/styles';
import { Link } from '@rocketlane/rocket-router';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  ${BodyShort01};
  position: absolute;
  right: 0;
  bottom: calc(var(--spacing-10) + var(--spacing-05) + 2.5 * var(--spacing-01));
  z-index: var(--zindex-elevated);
`;

type Props = {
  isSamlMandate: boolean;
  forgotPasswordLink: string;
};

export const ForgotPasswordLink = ({
  isSamlMandate,
  forgotPasswordLink,
}: Props) => {
  if (isSamlMandate) {
    return null;
  }

  return (
    <StyledLink to={forgotPasswordLink}>
      <FormattedMessage id="forgot_password" />
    </StyledLink>
  );
};
